export interface IReportParameters {
    reportVariant: string;
    payPeriod: string;
    employeeNumber: string;
    clientNumber: string;
    projectNumber: string;
    subcode: string;
    office: string;
    manager: string;
    extended: string;
    exclude90: string;
    billingApproval: string;
    workDescFormat: string;
    crewChief: string;
    ccNo: string;
}

export default class ReportParameters implements IReportParameters {
    reportVariant = '';
    payPeriod = '';
    employeeNumber = '';
    clientNumber = '';
    projectNumber = '';
    subcode = '';
    office = '';
    manager = '';
    extended = '';
    exclude90 = '';
    billingApproval = '';
    workDescFormat = '';
    crewChief = '';
    ccNo = '';
}


// WEBPACK FOOTER //
// ./src/models/AP/BillingSummaryReport.ts